"use client";

import { createContext, useContext, useState, ReactNode } from "react";

const AdminSidebarContext = createContext<{
    sidebar_open: boolean;
    set_sidebar_open: (open: boolean) => void;
}>({ sidebar_open: false, set_sidebar_open: () => {} });

export function AdminSidebarProvider({ children }: { children: ReactNode }) {
    const [sidebar_open, set_sidebar_open] = useState(false);
    return (
        <AdminSidebarContext.Provider value={{ sidebar_open, set_sidebar_open }}>
            {children}
        </AdminSidebarContext.Provider>
    );
}

export function useAdminSidebar() {
    return useContext(AdminSidebarContext);
}

